import Swiper from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core';
SwiperCore.use([Pagination]);

document.addEventListener("DOMContentLoaded", () => {
  let storyContainers = document.querySelectorAll('.wp-block-stories');
  if (storyContainers) {
    storyContainers.forEach((storyContainer) => {
      let swiperContainer = storyContainer.querySelector('.swiper-container');
      if (swiperContainer && swiperContainer.querySelectorAll('.swiper-slide').length > 1) {
        new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          centeredSlides: true,
          loopedSlides: 10,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
        });
      }
    });
  }
});
